import React from "react";
import { CircleFlag as BaseCircleFlag } from "react-circle-flags";

interface IProps {
    countryCode: string;
    diameter?: number;
}

export const CountryCircleFlag: React.FC<IProps> = ({ countryCode, diameter = 20 }) => {
    return (
        <BaseCircleFlag
            countryCode={countryCode.toLowerCase()}
            width={diameter}
            height={diameter}
            data-tag="allowRowEvents"
        />
    );
};
